import gql from 'graphql-tag'

export default gql`query getParkings {
  getParkings {
		id
		picto
    order
		updated_at
		details {
			id
      name
			phone
			content
			cta_label
			cta_url
			language_code
		}
	}
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/parking/getParkings.js